// Third-party imports
import $ from 'jquery';
import axios from 'axios';

import { updateAddGiftButtonLabel } from '../gift_catalogue/logic/button_handler.js';
import { updateCartButtonIndicator } from './updateCartIndicator.js';
import { renameProperties } from './postDonationProduct.js';
// These methods are used to post a product to the cart
// using the data from a multi-form.
// We assume that certain elements exist, and are id'ed specifically.
//
// The add button has an id: 'to_cart'

export function postGiftToCart(global, form) {
    let variantInCartElement = getVariantInCartElement(global);
    let isInCart = variantInCartElement !== null;
    //Rename the properties to add _(under score) for hiding in checkout page
    renameProperties(global);
    // Used to post the product in different ways...
    // postForm - simply posts the form as is
    // postFake - shows an update popup, but doesn't post any products
    // removeAndPost - removes the product from the cart, and then posts the form
    let postType = 'postForm';

    if (isInCart) {
        let add_button = global.document.getElementById('to_cart');
        if (!add_button) {
            return;
        }

        let quantityHook = global.document.querySelector('.js-quantity-hook');
        if (variantInCartElement.dataset.quantity !== quantityHook.value) {
            postType = 'removeAndPost';
        } else {
            postType = 'postFake';
        }
    }

    if (postType === 'postForm') {
        postForm(global, form);
    } else if (postType === 'postFake') {
        //showAddToCartPopup(global, true);
        removeAndReAddProduct(global, form);
    } else if (postType === 'removeAndPost') {
        removeAndReAddProduct(global, form);
    }
}

function postForm(global, form) {
    setAddButtonVisible(global, false);

    // The code below was got from the url below. This is how to post a multipart
    // form without navigating to the page
    // https://www.mkyong.com/jquery/jquery-ajax-submit-a-multipart-form/

    // Create an FormData object
    let data = new FormData(form);
    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: '/cart/add',
        dataType: 'json',
        data: data,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 5000,
        success: data => {
            // If the item was/is in the cart, we show
            // the popup as an update instead of an add
            //showAddToCartPopup(global, variantInCart);

            updateCartButtonIndicator();

            setInCartDataAttributes(global, data.variant_id, data.quantity);
            // Show the add button after 250 ms, to avoid spam clicks
            setTimeout(() => {
                setAddButtonVisible(global, true);
            }, 250);
            $('input[type="radio"][name="Options"]:checked').attr(
                'qty-in-cart',
                data.quantity
            );
        },
        error: e => {
            let err = {
                msg: 'POST failed for adding item to cart',
                data: e,
            };
            throw err;
        },
    });
}

// Removes the product from the cart, then readds it with the updated data
function removeAndReAddProduct(global, form) {
    let add_button = global.document.getElementById('to_cart');
    if (!add_button) {
        return;
    }
    let product_id = getVariantIDBeingPosted(global);

    axios
        .post('/cart/change.js', {
            id: product_id,
            quantity: 0,
        })
        .then(() => {
            postForm(global, form);
        })
        .catch(error => {
            let err = {
                msg: 'Unexpected error',
                data: error,
            };
            throw err;
        });
    // The following only applies to OGC re-designed pages.
    // we wrap this functionality inside an IF statement with an element
    // that only appears on the re-designed product page.
    let viewButton = $('#view_basket');
    if (viewButton) {
        setTimeout(function() {
            $('.qtyChange-hook').hide();
            add_button.classList.add('button--removed');
            viewButton.removeClass('button--removed');
        }, 1000);
    }
}

// Get the variant id hook in the form and return the value
function getVariantIDBeingPosted(global) {
    let variantIDHook = global.document.querySelector('.js-variantID-hook');
    return variantIDHook.value;
}

// Checks if there's an element with the variant id passed
// which would mean that the variant is in the cart.
// Returns the element, which can be used to determine
// if the variant is in the cart by checking if the return value is null, but also
// the quantity that is in the cart can also be retrieved from the element
function getVariantInCartElement(global) {
    let variantIDBeingPosted = getVariantIDBeingPosted(global);
    let elementID = `variant_id_${variantIDBeingPosted}`;
    let variantInCartElement = global.document.getElementById(elementID);
    return variantInCartElement;
}

// Add the variant id to the list of elements that track if the variant is in
// the cart if it does not already exist.
// Also update the quantity data attribute of the element.
function setInCartDataAttributes(global, postedVariantID, postedQuantity) {
    let variantElement = getVariantInCartElement(global);

    if (!variantElement) {
        variantElement = global.document.createElement('div');
        variantElement.setAttribute('id', `variant_id_${postedVariantID}`);

        global.document
            .getElementById('inCartVariants')
            .appendChild(variantElement);
    }

    variantElement.dataset.quantity = postedQuantity;

    updateAddGiftButtonLabel();
}

// Hide the spinner and show the add to cart button or
// Show the spinner and hide the add to cart button
function setAddButtonVisible(global, visible) {
    let add_button = global.document.getElementById('to_cart');
    if (!add_button) {
        return;
    }

    let spinner = add_button.querySelector('#addButtonSpinner');
    let addButtonLabel = add_button.querySelector('#addButtonLabel');

    if (!spinner || !addButtonLabel) {
        return;
    }

    if (visible) {
        spinner.classList.add('u-hide');
        addButtonLabel.style.setProperty('visibility', 'visible');
    } else {
        addButtonLabel.style.setProperty('visibility', 'hidden');
        spinner.classList.remove('u-hide');
    }
}
